export const USER_NOT_FOUND_CODE = 'user-not-found';
